import React from 'react';
import ContactSection from '../components/ContactSection';
import Map from '../components/Map';
import GoogleMap from '../components/GoogleMap';
import Footer from '../components/Footer';

export default function Contact() {
  return (
    <div>
      <ContactSection />
      <Footer />
    </div>
  );
}
